/**
 * Utilitários gerais para a aplicação
 */

/**
 * Gera uma string aleatória com o tamanho especificado
 * Útil para gerar tokens de segurança como o state parameter do OAuth
 * 
 * @param length Tamanho da string a ser gerada
 * @returns String aleatória
 */
export const generateRandomString = (length: number): string => {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  
  const charactersLength = characters.length;
  const randomValues = new Uint32Array(length);
  
  // Usando crypto.getRandomValues para maior segurança quando disponível
  if (window.crypto && window.crypto.getRandomValues) {
    window.crypto.getRandomValues(randomValues);
    
    for (let i = 0; i < length; i++) {
      result += characters.charAt(randomValues[i] % charactersLength);
    }
  } else {
    // Fallback para Math.random se crypto não estiver disponível
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
  }
  
  return result;
};

/**
 * Formata uma data para exibição no formato local
 * 
 * @param date Data a ser formatada (string ISO ou objeto Date)
 * @returns String formatada da data
 */
export const formatDate = (date: string | Date): string => {
  if (!date) return '';
  
  const dateObj = typeof date === 'string' ? new Date(date) : date;
  
  return dateObj.toLocaleDateString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  });
};

/**
 * Trunca um texto para o tamanho máximo especificado
 * 
 * @param text Texto a ser truncado
 * @param maxLength Tamanho máximo permitido
 * @returns Texto truncado com reticências se necessário
 */
export const truncateText = (text: string, maxLength: number): string => {
  if (!text || text.length <= maxLength) return text;
  
  return text.substring(0, maxLength) + '...';
}; 